import React from "react";
import { Link } from "gatsby";
import { Title } from "../Core";

const Logo = ({ color = "front", _height, className = "", ...rest }) => {
  return (
    <Link to="/" className={`${className}`} {...rest}>
      <Title color={color} variant="cardLg" className="mb-0">
        dioscuro.
      </Title>
    </Link>
  );
};

export default Logo;
